module.exports = __webpack_public_path__ + "media/images/map/ligne15-ffc68b02af3f61fa4bfce140eab76795.png";